import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Landing from "./pages/Landing";
import MvCreator from "./pages/MvCreator";
import ClipShare from "./pages/ClipShare";
import Studio from "./pages/Studio";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import Account from "./pages/Account";
import PaymentResult from "./pages/PaymentResult";

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/studio" element={<MvCreator />} />
          <Route path="/mixer" element={<Studio />} />
          <Route path="/clip/:id" element={<ClipShare />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/login" element={<Login />} />
          <Route path="/account" element={<Account />} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult />} />
        </Routes>
        </ErrorBoundary>
      </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
